import { atom } from "jotai";

import { retrieveFromSessionStorage } from "../../utils";

import { INTRO_MODAL_SWEEP_TOTAL_ENTRIES } from "./arcade-intro-modal.constants";

export const showIntroModalAtom = atom<boolean>(
  retrieveFromSessionStorage(INTRO_MODAL_SWEEP_TOTAL_ENTRIES) !== null
);
